const c = {
  name: "Wombat",
  dimensions: { width: 40, height: 34 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 34" style="enable-background:new 0 0 40 34;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,22c-1,0-1.9,0.3-2.7,0.8C16.6,23.2,16,24,16,25c0,0.9,0.5,1.9,1.1,2.6c0.7,0.7,1.7,1.4,2.9,1.4
			c1.2,0,2.2-0.7,2.9-1.4c0.6-0.7,1.1-1.7,1.1-2.6c0-1-0.6-1.8-1.3-2.2C21.9,22.3,21,22,20,22z M18,25c0-0.1,0.1-0.3,0.4-0.6
			c0.4-0.2,0.9-0.4,1.6-0.4s1.2,0.2,1.6,0.4c0.4,0.2,0.4,0.5,0.4,0.6c0,0.2-0.2,0.7-0.6,1.2C20.9,26.7,20.4,27,20,27
			c-0.4,0-0.9-0.3-1.4-0.8C18.2,25.7,18,25.2,18,25z"/>
		<path class="st0" d="M15,21.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C13.8,20.7,14.3,21.2,15,21.2z"
			/>
		<path class="st0" d="M26.3,20c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C25.7,18.7,26.3,19.3,26.3,20z"
			/>
		<path class="st0" d="M20,0c-3,0-5.9,0.7-8.5,1.9C10.2,0.7,8.4,0,6.5,0H0v7c0,1.8,0.7,3.4,1.8,4.7C0.6,14.2,0,17,0,20v2
			c0,5.5,4.5,10,10,10c1.5,0,3-0.4,4.3-1c1.3,1.8,3.3,3,5.7,3c2.4,0,4.5-1.2,5.7-3c1.3,0.6,2.7,1,4.3,1c5.5,0,10-4.5,10-10v-2
			c0-3-0.6-5.8-1.8-8.3C39.3,10.4,40,8.8,40,7V0h-6.5c-1.9,0-3.7,0.7-5,1.9C25.9,0.7,23,0,20,0z M30.4,2.9C31.3,2.3,32.3,2,33.5,2
			H38v5c0,1-0.3,2-0.8,2.7C35.5,7,33.2,4.6,30.4,2.9z M6.5,2c1.1,0,2.2,0.3,3.1,0.9C6.8,4.6,4.5,7,2.8,9.7C2.3,9,2,8,2,7V2H6.5z
			 M2,20c0-9.9,8.1-18,18-18s18,8.1,18,18v2c0,4.4-3.6,8-8,8c-1.5,0-2.9-0.4-4.1-1.2l-0.9-0.6l-0.5,1C23.6,30.9,21.9,32,20,32
			c-1.9,0-3.6-1.1-4.5-2.8l-0.5-1l-0.9,0.6C12.9,29.6,11.5,30,10,30c-4.4,0-8-3.6-8-8V20z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Wombat
};
